import React from 'react';

import styled from 'styled-components';

export const StepperContainer = styled.div`
  background-color: #ffffff;
  width: 100%;
  max-width: 780px;
  margin: 0 auto;
  padding: 1.25rem 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 1rem;
    border-radius: 8px;
  }
`;

export const StepperHeader = styled.div`
  margin-bottom: 2rem;
`;

export const StepText = styled.div`
  font-size: 0.875rem;
  color: #283618;
  margin-bottom: 0.75rem;
  font-weight: 500;
`;

export const ProgressBar = styled.div`
  display: flex;
  width: 100%;
  height: 4px;
  background-color: transparent;
  margin-top: 0.5rem;
  gap: 8px;
`;

export const ProgressStep = styled.div`
  flex: 1;
  height: 100%;
  background-color: ${(props) => (props.active ? '#283618' : '#e5e5e5')};
  border-radius: 2px;
`;

export const StepContent = styled.div`
  margin-bottom: 2rem;
  position: relative;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;

export const Button = styled.button`
  font-family: 'Spectral-Regular', serif;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  font-weight: 500;
`;

export const PrevButton = styled(Button)`
  font-family: 'Spectral-Regular', serif;
  background-color: white;
  color: #283618;
  border: 1px solid #e0e0e0;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const NextButton = styled(Button)`
  font-family: 'Spectral-Regular', serif;
  background-color: ${(props) => (props.disabled ? '#cccccc' : '#283618')};
  color: white;
  border: 1px solid ${(props) => (props.disabled ? '#cccccc' : '#283618')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover {
    background-color: ${(props) => (props.disabled ? '#cccccc' : '#1e2a13')};
  }
`;

export const LeftArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: '8px' }}
  >
    <path
      d="M10 12L6 8L10 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginLeft: '8px' }}
  >
    <path
      d="M6 4L10 8L6 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
